import { useNavigate } from 'react-router-dom'
import type { Collection } from '../lib/types'
import { useCreatorStore } from '../stores/creatorStore'

function timeAgo(dateStr: string): string {
  const diff = Date.now() - new Date(dateStr).getTime()
  const mins = Math.floor(diff / 60000)
  if (mins < 1) return 'now'
  if (mins < 60) return `${mins}m ago`
  const hrs = Math.floor(mins / 60)
  if (hrs < 24) return `${hrs}h ago`
  const days = Math.floor(hrs / 24)
  return `${days}d ago`
}

const STATUS_STYLES: Record<string, { bg: string; text: string; label: string }> = {
  collecting: { bg: 'bg-blue-500/15', text: 'text-blue-400', label: 'Collecting' },
  drafting: { bg: 'bg-yellow-500/15', text: 'text-yellow-400', label: 'Drafting' },
  completed: { bg: 'bg-green-500/15', text: 'text-green-400', label: 'Completed' },
}

export default function CollectionCard({ collection }: { collection: Collection }) {
  const navigate = useNavigate()
  const { deleteCollection } = useCreatorStore()

  const status = STATUS_STYLES[collection.status] || STATUS_STYLES.collecting

  return (
    <div
      onClick={() => navigate(`/creator/${collection.id}`)}
      className="bg-surface rounded-lg p-4 cursor-pointer hover:bg-elevated transition-colors active:scale-[0.98]"
    >
      <div className="flex items-start justify-between gap-2">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2">
            <h3 className="font-medium truncate">{collection.title}</h3>
            <span className={`shrink-0 px-2 py-0.5 rounded text-xs ${status.bg} ${status.text}`}>
              {status.label}
            </span>
          </div>
          <div className="flex items-center gap-3 mt-1 text-sm text-text-muted">
            <span>{collection.item_count} item{collection.item_count !== 1 ? 's' : ''}</span>
            <span>{timeAgo(collection.created_at)}</span>
          </div>
        </div>
        <button
          onClick={(e) => { e.stopPropagation(); deleteCollection(collection.id) }}
          className="p-2 rounded-lg hover:bg-bg transition-colors text-text-muted hover:text-error shrink-0"
          title="Delete"
        >
          <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
          </svg>
        </button>
      </div>
    </div>
  )
}
